import { Responsive } from '@cian/ui-kit';
import { MobileSlidingContainer } from '@cian/frontend-mobile-sliding-container';
import * as React from 'react';

import { ChatContainer } from '../../containers/ChatContainer';
import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import { ErrorContainer } from '../../containers/ErrorContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';
import { BottomNavigationContainer } from '../../containers/BottomNavigationContainer';

export const MobilePage = () => {
  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />
      <ResultsMobileContainer />
      <ResultsEmptyContainer />
      <ShowMoreBtnContainer />
      <ChatContainer />
      <ErrorContainer />
      <Responsive tablet phone>
        <MobileSlidingContainer>
          <BottomNavigationContainer />
        </MobileSlidingContainer>
      </Responsive>
    </>
  );
};
